module.exports = __webpack_public_path__ + "static/media/total_equipment.4939b793.svg";